class Filter {

    constructor() {
        var year = URLParam('year');

        year = year ? year : $('[data-videos] [name="year"]:eq(0)').val();

        if (year) {
            history.pushState(false, false, location.href.replace('?year=' + year, ''));
            $('[data-videos] [name="year"][value="' + year + '"]').prop('checked', true);
        }

        const showYear = (year) => {
            $('[data-location-year]').hide();
            $('[data-location-year="' + year + '"]').show();
        }

        showYear(year);

        $(document)
            .on('change', '[data-videos] [name]', (e) => {
                var elem = $(e.currentTarget);

                if (elem.attr('name') == 'year') {
                    if (elem.val() == '4') {
                        $('[data-location-year]').each(function () {
                            $(this).find('[name]:eq(0)').prop('checked', true).trigger('change.select');
                        });
                        $('[data-location-year]').css('opacity', '0.3');
                        $('[data-location-year]').css('cursor', 'default');
                        $('[data-location-year]').css('pointer-events', 'none');
                    } else {
                        $('[data-location-year]').css('opacity', '1');
                        $('[data-location-year]').css('cursor', 'pointer');
                        $('[data-location-year]').css('pointer-events', '');

                        showYear(elem.val());
                    }
                }

                items.update('video');
            });
    }

    get() {
        var data = {};

        if ($('[data-videos] [name="date"]:checked').length) {
            data.date = $('[data-videos] [name="date"]:checked').val();
        } else {
            data.date = $('[data-videos] [name="date"]').val();
        }

        if ($('[data-videos] [name="year"][value="2021"]').prop('checked')) {
            data.location_id = $('[data-videos] [name="location_id"] [selected]').val();
        } else {
            data.location_id = $('[data-videos] [name="location_id_2020"] [selected]').val();
        }

        if(!data.location_id) {
            delete data.location_id;
        }

        data.industry_id = $('[data-videos] [name="industry_id"]:checked').val();

        if ($('[data-videos] [name="year"][value="4"]:checked').length) {
            data.category_id = 4;
        } else {
            if ($('[name="year"]:checked').length) {
                data.year = $('[name="year"]:checked').val();
            }
        }

        if (location.href.indexOf('/video') > -1) {
            data.paginate = 8;
        }

        return data;
    }

}

export default new Filter();